import React from 'react';
import { experiences } from '../data/portfolioData';
import useScrollReveal from '../hooks/useScrollReveal';
import './Experience.css';

const Experience: React.FC = () => {
  const { ref, isVisible } = useScrollReveal();

  return (
    <section id="experience" className="section experience" ref={ref}>
      <div className={`container ${isVisible ? 'revealed' : 'hidden-section'}`}>
        <h2 className="section-title">Esperienza</h2>
        <p className="section-subtitle">
          Il percorso professionale sarà aggiunto dopo aver confermato i dettagli e le informazioni condivisibili.
        </p>
        {experiences.length > 0 && (
          <div className="timeline">
            {experiences.map((exp, index) => (
              <div key={exp.id} className="timeline-item animate-fade-in-up" style={{ animationDelay: `${index * 0.15}s` }}>
                <div className="timeline-period">{exp.period}</div>
                <h3 className="timeline-role">{exp.role}</h3>
                <div className="timeline-company">
                  {exp.companyUrl ? <a href={exp.companyUrl} target="_blank" rel="noopener noreferrer">@ {exp.company}</a> : <span>@ {exp.company}</span>}
                </div>
                <p className="timeline-description">{exp.description}</p>
                <ul className="timeline-highlights">{exp.highlights.map((highlight, i) => <li key={i}>{highlight}</li>)}</ul>
                <div className="timeline-tech">{exp.technologies.map(technology => <span key={technology} className="timeline-tech-tag">{technology}</span>)}</div>
              </div>
            ))}
          </div>
        )}
      </div>
    </section>
  );
};

export default Experience;
